export default {
  noResultFoundFor: 'No result found for',
  search: 'Search',
} as const;
